
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes, createFactory } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// utilities
import cx from 'classnames';
import _ from 'lodash';
import deepUnset from '../../../../lib/deepUnset';

// action creators for redux
import * as syncActionCreators from '../../../../redux/actionCreators/sync';
import * as asyncActionCreators from '../../../../redux/actionCreators/async';

// form components
import RaisedButton from '../../../../common/components/c_RaisedButton';
import FlatButton from '../../../../common/components/c_FlatButton';
import ModalForm from '../../../../common/components/c_ModalForm';
import PrelimMessage from '../../../f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/f_PrelimMessage';

// components lookup
import {getCurrent} from './componentLookup';

// Skill components
import SkillSection from './Skills/c_SkillSection';

// ui components
import * as ui from '../../../../redux/actionCreators/sync/ui';
import * as applicationStatus from '../../../applicant/helpers/status';

// styling obj
const nextButtonStyle= {
  width: '296px',
  height: '45px'
};

const formModes = {
  DEFAULT: 1,
  NOTREADY: 2
};

@connect(state => ({
  user: state.user,
  profile: state.applicantProfile,
  workExperiences: state.workExperiences,
  employmentGaps: state.employmentGaps,
  education: state.education,
  licenses: state.licenses,
  skills: state.skills,
  documents: state.documents,
  references: state.references,
  staticData: state.staticData,
  tempState: state.tempState,
  associations: state.associations,
  designations: state.designations,
  hideControls: state.ui.hideControls,
}))
export default class ApplicationForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    workExperiences: PropTypes.object.isRequired,
    employmentGaps: PropTypes.object.isRequired,
    education: PropTypes.object.isRequired,
    references: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    className: PropTypes.string,
    navStateChange: PropTypes.func,
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
    stepBackward: PropTypes.func,
    stepForward: PropTypes.func,
    submitApplication: PropTypes.func,
    activeColumnNav: PropTypes.string,
    activeRowSubNav: PropTypes.string,
    tempState: PropTypes.object.isRequired,
    skills: PropTypes.object,
    associations: PropTypes.object,
    designations: PropTypes.object,
    submitReady: PropTypes.bool,
    hideControls: PropTypes.bool,
    formSections: PropTypes.object,
    appViewState: PropTypes.object,
  }

  constructor() {
    super();

    // error count tracker
    // Is on the instance to avoid it being overwritten
    // by multiple setStates firing.
    this.errorCount = 0;

    this.updateErrorState = newCount =>
      this.setState({
        ...this.state,
        errorCount: newCount
      });

    this.errorUpdate = countChange => {
      this.errorCount += countChange;
      this.updateErrorState(this.errorCount);
    };

    this.getCurrentComponent = ::this.getCurrentComponent;
  }


  state = {
    errorCount: 0,
    mode: formModes.DEFAULT,
    valid: true,
    customError: null,
    submitError: null,
  }

  setCustomError(message)  {
    // hack so state actually gets state
    setTimeout(() => this.setState({customError: message}));
  }

  setSubmitError(message)  {
    // hack so state actually gets state
    setTimeout(() => this.setState({submitError: message}));
  }

  // only debouncing on front end
  componentDidMount() {
    // delaying actual state update to avoid collisions
    this.updateErrorState = _.debounce(this.updateErrorState, 100);
  }

  componentWillReceiveProps(nextProps) {
    // clear tempState when we switch pages
    if(this.props.activeColumnNav !== nextProps.activeColumnNav || this.props.activeRowSubNav !== nextProps.activeRowSubNav) {
      this.setCustomError(null);
      if(!_.isEmpty(this.props.tempState)) {
        this.props.dispatch(syncActionCreators.updateTempState({}));
      }

      if(!this.state.valid) {
        this.setState({
          valid: true
        });
      }
    }
  }

  onSubmitValidate = () => {
    const currentComponent = this.getCurrentComponent(this.props.activeColumnNav, this.props.activeRowSubNav);
    // If submitValidator defined in component, we also need to validate it before "continue".
    // This validation only for continue button, not used in "save".

    if (currentComponent.submitValidator) {
      const items = _.filter(_.merge({}, this.props[currentComponent.model], this.props.tempState[currentComponent.model]), (item) => item !== Symbol.for('__delete'));
      if (!currentComponent.submitValidator(items)) {
        this.setSubmitError(currentComponent.submitErrorMessage);
        return false;
      }
    }
    return true;
  }

  onSave = () => {
    // reset errors.
    this.setSubmitError(null);
    const formState = _.merge({}, this.state);

    // currentForm is either standalone React component or a React component wrapped in a HOC
    // in case of currentForm being wrapped in a HOC, we need to getWrappedInstance to access the inner wrapped component's refs
    const validateFunc = this.refs.currentForm.validateForm ? this.refs.currentForm.validateForm : this.refs.currentForm.getWrappedInstance().validateForm;
    formState.valid = validateFunc();

    if(this.refs.currentForm && formState.valid) {
      // if (!_.isEmpty(this.props.tempState)) {
        // retrieve gurrent component from static data
        const currentComponent = this.getCurrentComponent(this.props.activeColumnNav, this.props.activeRowSubNav);
        // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
        const newState = _.cloneDeep(this.props.tempState);
        _.set(newState, 'user.id', _.get(this.props.user, 'impersonateUser.id', this.props.user.id));
        _.set(newState, 'profile.id', this.props.profile.id);

        const objPath = `profile.viewState.progress.applicant.application.${currentComponent.viewModel}.done`;
        _.set(newState, objPath, true);

        newState.profile.viewState = _.merge(
          {},
          { progress:{applicant:{application: this.props.appViewState || {} }}},
          this.props.profile.viewState,
          newState.profile.viewState
        );


        // update front end
        this.props.dispatch(
          syncActionCreators.updateApplicant(newState)
        );

        let actions = (currentComponent.saveFunc || asyncActionCreators.persistApplicantUpdate)(newState);
        actions = _.isArray(actions) ? actions : [actions];

        if (!_.isNil(this.props.profile.dateAuthorized) && this.props.activeColumnNav === 'Skills') {
            actions.push(push('/applicant/Summary of Skills/Summary of Skills'));
        }

        // update back end
        actions = actions.map(action => this.props.dispatch(action));

        if (!_.isNil(this.props.profile.dateAuthorized)) {
          Promise.all(actions)
          .then(() => this.props.dispatch(ui.showSnackBar('Your information has been saved.')))
          .catch(() => console.warn('Error updating application'));
        }
    }

    this.setState(formState);
    return formState.valid;
  }

  onBack = () => {
    this.setCustomError(null);
    this.props.stepBackward();
  }

  onNext = () => {
    if (this.onSubmitValidate() && this.onSave()) {
      if (!this.props.stepForward()) {
        this.setState({...this.state, mode: formModes.NOTREADY});
      }
      else {
        this.setCustomError(null);
      }
    }
  }

  onSubmit = () => {
    if (this.onSave()) {
      this.props.submitApplication();
    }
  }

  handleCloseModal = () => {
    this.setState({...this.state, mode: formModes.DEFAULT});
  }

  // modify tempState properties
  updateTempState = (parent, prop, event, val, cb) => {
    // reset errors.
    this.setSubmitError(null);
    this.setState({valid: true});
    const newTempState = _.cloneDeep(this.props.tempState);
    const propPath = parent && !prop ? parent : !parent && prop ? prop : `${parent}${prop[0] === '[' ? '' : '.'}${prop}`;

    if(val === undefined) {
      // unsets parent objects if they are empty
      deepUnset(newTempState, propPath);
    } else {
      _.setWith(newTempState, propPath, val, Object);
    }

    this.props.dispatch(
      syncActionCreators.updateTempState(newTempState)
    );

    if(typeof cb === 'function') {
      cb();
    }
  }

  renderNotReady() {
    return (
      <ModalForm onClose={this.handleCloseModal}
                 className={'application-welcome-message prelim-message'}
                 button={{
                    label: 'Close',
                    onClick: this.handleCloseModal
                }}>
        <PrelimMessage
          profile={this.props.profile}
          />
      </ModalForm>
    );
  }

  getCurrentComponent(activeColumnNav, activeRowSubNav) {
    if (activeColumnNav === 'Skills' && activeRowSubNav !== 'Instructions') {
      // return a obj of props including a component prop

      const skillType = this.props.staticData.skillCategoryTypes.find((skill) => {
        return skill.url_query_string === activeRowSubNav;
      });

      const viewModel = activeRowSubNav ? `${activeColumnNav}.${activeRowSubNav}` : activeColumnNav;

      const skillObj = {
        component: createFactory(SkillSection),
        model: 'skills',
        categoryId: skillType.id,
        title: skillType.title,
        description: skillType.applicantDescription,
        viewModel,
        validation: { [skillType.url_query_string]: {
          custom: {
            func: val => !_.isEmpty(val),
            message: 'Must Select at Least One'
          }
        }},
        validationKey: skillType.url_query_string,
        customErrorMessage: 'Please Select at Least One Item.',
        hasNone: skillType.hasNone,
        saveFunc(tempState) {
          return asyncActionCreators.persistSkills(tempState);
        },
      };
        return skillObj;
      } else {
        return getCurrent(activeColumnNav, activeRowSubNav);
      }
    }

  render() {

    const {
        component,
        ...staticProps
      } = this.getCurrentComponent(this.props.activeColumnNav, this.props.activeRowSubNav);

    const applicantStatus = _.get(this.props, 'profile.applicantStatus', 0);
    const submitted = !!_.get(this.props, 'profile.dateAuthorized', false);
    const interviewed = applicationStatus.hasInterviewed(applicantStatus);
    const isInactivePipeline = applicationStatus.isInactivePipeline(applicantStatus);
    const isImpersonatedUser = !_.isEmpty(this.props.user.impersonateUser);

    return (
        <div className={`application-form ${this.props.className}`}>

          { component ? //simple validation for defined component. if it's not present or undefined - will not be rendered and no error occure;
            component({
              ...(typeof staticProps.model === 'string' ? {
                [staticProps.model]: this.props[staticProps.model]
              } :
              Array.isArray(staticProps.model) ?
                _.fromPairs(staticProps.model.map(model => [model, this.props[model]])) :
              {}),
              ...staticProps,
              user: !_.isEmpty(this.props.user.impersonateUser) ? this.props.user.impersonateUser : this.props.user,
              profile: this.props.profile,
              ref: 'currentForm',
              adminView: false,
              submitted,
              workExperiences: this.props.workExperiences,
              dispatch: this.props.dispatch,
              viewState: _.get(this.props.profile.viewState, `progress.applicant.application.${staticProps.viewModel}`),
              profileId: this.props.profile.id,
              staticData: this.props.staticData,
              errorCount: this.state.errorCount,
              errorUpdate: this.errorUpdate,
              tempState: this.props.tempState,
              updateTempState: this.updateTempState,
              onSave: this.onSave,
              setErrorMessage: this.setCustomError.bind(this),
              formSections: this.props.formSections
            }) : null
          }


          { component && !this.props.hideControls ?
          <div className='application-form-controls'>
            <div className='left-container'>
              {
                !this.props.isLast && !submitted
                &&
                <div
                  className={cx('text-btn save noTextSelect')}
                  data-id='Save'
                  onClick={this.props.isLast ? this.onSubmit : this.onSave}
                >
                  Save
                </div>
              }
              {
                interviewed
                && !submitted
                && (!isInactivePipeline || isImpersonatedUser) // only show resume button in inactive pipeline if non-applicant view
                &&
                <a target='_blank' className='view-resume-btn' href='/applicant/resume'>
                  <FlatButton className='view-resume-btn'
                              label='View Resume'
                              style={{
                                display: 'inline-block',
                                width: 'auto',
                                paddingLeft: '50px',
                                paddingRight: '50px',
                                marginTop: '50px',
                                float: 'right'
                              }}/>
                </a>
            }
            {
              this.state.submitError
              &&
              <div className='error-message'>{this.state.submitError}</div>
            }
            {
              !this.state.valid
              &&
              <div className='error-message'>{this.state.customError || staticProps.customErrorMessage || 'Please fill out the required fields above.'}</div>
            }
            </div>
            <div className='right-container'>
              {
                !submitted
                &&
                <div
                  className={cx('text-btn back noTextSelect', {disabled: this.props.isFirst})}
                  data-id='Back'
                  onClick={!this.props.isFirst && this.onBack || null}
                >
                  Back
                </div>
              }
              {
                // Submit Button if not yet submitted
                !submitted
                && (!isInactivePipeline || isImpersonatedUser) // Show if Active or (Inactive and Admin)
                &&
                <RaisedButton
                  disabled={this.props.isLast && (!this.props.submitReady || _.get(this.props.tempState, 'profile.dateAuthorized', '').length === 0)}
                  label={(this.props.isLast) ? 'Submit' : 'Next'}
                  data-id={this.props.isLast ? 'Submit Button' : 'Next Button'}
                  style={nextButtonStyle}
                  onClick={this.props.isLast ? this.onSubmit : this.onNext}
                />
              }
              {
                // Save Button if already submitted
                submitted
                && (!isInactivePipeline || isImpersonatedUser) // Show if Active or (Inactive and Admin)
                &&
                <RaisedButton
                  disabled={this.props.activeColumnNav === 'Submit' && submitted}
                  label={'Save'}
                  data-id={'Save'}
                  style={nextButtonStyle}
                  onClick={this.onSave}
                />
              }
            </div>

          </div>
          : null}
          {
            (this.state.mode === formModes.NOTREADY) && this.renderNotReady()
          }
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/index.js